
// import React from "react";
// import {
//   Card,
//   Row,
//   Col,
//   Radio,
//   Input,
//   DatePicker,
//   Form,
//   Tag,
// } from "antd";
// import dayjs from "dayjs";



// function MidcLandForm({ form,tracking,stepKey }) {
//   const sectionDateMap = {
//       midc_1: tracking?.section1_planned_date,
//       midc_2: tracking?.section2_planned_date,
//       midc_3: tracking?.section3_planned_date,
//   };

//   const renderSectionTitle = (title) => (
//       <div
//           style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//           }}
//       >
//           <span>{title}</span>

//           {sectionDateMap[stepKey] && (
//               <Tag color="blue">
//                   Planned:{" "}
//                   {dayjs(sectionDateMap[stepKey]).format(
//                       "DD MMM YYYY"
//                   )}
//               </Tag>
//           )}
//       </div>
//   );

//   // ── STEP 1: Land Demand & Type ─────────────────────────────────────────────
//   if (stepKey === "midc_1") {
//     return (
//       <Form form={form} layout="vertical">
//         <Card className="scheme-section-card" title={renderSectionTitle("LAND DEMAND & TYPE")}>
//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Whether Govt. Land available</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={6}>
//                 <Form.Item name="whether_govt_land_available_status" label="Status">
//                   <Radio.Group>
//                     <Radio value="YES">Yes</Radio>
//                     <Radio value="NO">No</Radio>
//                     <Radio value="PENDING">Pending</Radio>
//                   </Radio.Group>
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>
//         </Card>
//       </Form>
//     );
//   }

//   // ── STEP 2: Land Identification & Feasibility ──────────────────────────────
//   if (stepKey === "midc_2") {
//     return (
//       <Form form={form} layout="vertical">
//         <Card className="scheme-section-card" title={renderSectionTitle("LAND IDENTIFICATION & FEASIBILITY")}>

//           {/* Whether MIDC land identified */}
//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Whether MIDC land identified?</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={4}>
//                 <Form.Item name="whether_midc_land_identified_status" label="Status">
//                   <Radio.Group>
//                     <Radio value="YES">Yes</Radio>
//                     <Radio value="NO">No</Radio>
//                   </Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="whether_midc_land_identified_date_actual" label="Date Actual">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={15}>
//                 <Form.Item name="whether_midc_land_identified_remarks" label="Remarks">
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Most Feasible Land Identified - Added as requested */}
//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Most feasible land identified</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={4}>
//                 <Form.Item name="most_feasible_land_identified_status" label="Status">
//                   <Radio.Group>
//                     <Radio value="YES">Yes</Radio>
//                     <Radio value="NO">No</Radio>
//                   </Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={5}>
//                 <Form.Item name="most_feasible_land_identified_date_actual" label="Date Actual">
//                   <DatePicker style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={15}>
//                 <Form.Item name="most_feasible_land_identified_remarks" label="Remarks">
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Feasibility Electrical */}
//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Feasibility ascertainment done (Electrical)</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={4}>
//                 <Form.Item name="feasibility_ascertainment_done_electrical_status" label="Status">
//                   <Radio.Group>
//                     <Radio value="YES">Yes</Radio>
//                     <Radio value="NO">No</Radio>
//                   </Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={20}>
//                 <Form.Item name="feasibility_ascertainment_done_electrical_remarks" label="Remarks">
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Feasibility Civil */}
//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Feasibility ascertainment done (Civil)</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={4}>
//                 <Form.Item name="feasibility_ascertainment_done_civil_status" label="Status">
//                   <Radio.Group>
//                     <Radio value="YES">Yes</Radio>
//                     <Radio value="NO">No</Radio>
//                   </Radio.Group>
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={20}>
//                 <Form.Item name="feasibility_ascertainment_done_civil_remarks" label="Remarks">
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Details of Feasible Land (without title as requested) */}
//           <Card className="tracking-item-card">
//             <Row gutter={[16, 12]}>
//               <Col xs={24}>
//                 <Form.Item name="title" label="TITLE">
//                   <Input placeholder="e.g. details of feasible land" />
//                 </Form.Item>
//               </Col>
//             </Row>

//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={12}>
//                 <Form.Item name="survey_no_status" label="SURVEY / GUT NO">
//                   <Input placeholder="e.g. Plot No. E-21 / GUT-412 (Part)" />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={12}>
//                 <Form.Item name="mouje_status" label="MOUJE">
//                   <Input placeholder="e.g. Chakan" />
//                 </Form.Item>
//               </Col>
//             </Row>

//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={12}>
//                 <Form.Item name="taluka_status" label="TALUKA">
//                   <Input placeholder="e.g. Khed" />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={12}>
//                 <Form.Item name="district_status" label="DISTRICT">
//                   <Input placeholder="e.g. Pune" />
//                 </Form.Item>
//               </Col>
//             </Row>

//             <Row gutter={[16, 12]}>
//               <Col xs={24}>
//                 <Form.Item name="survey_no_remarks" label="REMARKS">
//                   <Input.TextArea rows={4} placeholder="Enter detailed remarks..." />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Area of feasible land */}
//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Area of feasible land (Ha/R)</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={8}>
//                 <Form.Item name="area_of_feasible_land_ha_r_status" label="Area">
//                   <Input placeholder="e.g. 1.80 Hectares" />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={16}>
//                 <Form.Item name="area_of_feasible_land_ha_r_remarks" label="Remarks">
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//           {/* Distance from load centre */}
//           <Card className="tracking-item-card">
//             <h4 className="tracking-question-label">Distance from load centre (km)</h4>
//             <Row gutter={[16, 12]}>
//               <Col xs={24} md={8}>
//                 <Form.Item name="distance_from_load_centre_km_status" label="Distance">
//                   <Input placeholder="e.g. 1.2 km" />
//                 </Form.Item>
//               </Col>
//               <Col xs={24} md={16}>
//                 <Form.Item name="distance_from_load_centre_km_remarks" label="Remarks">
//                   <Input />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Card>

//         </Card>
//       </Form>
//     );
//   }

//   // ── STEP 3: Proposal Submission ────────────────────────────────────────────
//   if (stepKey === "midc_3") {
//     const proposalRows = [
//       {
//         label: "Whether requirement of land is submitted to MIDC office?",
//         status: "whether_requirement_of_land_is_submitted_to_midc_office_status",
//         actual: "whether_requirement_of_land_is_submitted_to_midc_office_date_actual",
//         remarks: "whether_requirement_of_land_is_submitted_to_midc_office_remarks",
//       },
//       {
//         label: "Whether online application submitted on MIDC portal?",
//         status: "whether_online_application_submitted_on_midc_portal_status",
//         actual: "whether_online_application_submitted_on_midc_portal_date_actual",
//         remarks: "whether_online_application_submitted_on_midc_portal_remarks",
//       },
//       {
//         label: "Whether MIDC office given demand letter for EMD?",
//         status: "whether_midc_office_given_demand_letter_for_emd_status",
//         actual: "whether_midc_office_given_demand_letter_for_emd_date_actual",
//         remarks: "whether_midc_office_given_demand_letter_for_emd_remarks",
//       },
//       {
//         label: "Whether approval of CA sought for payment of EMD?",
//         status: "whether_approval_of_ca_sought_for_payment_of_emd_status",
//         actual: "whether_approval_of_ca_sought_for_payment_of_emd_date_actual",
//         remarks: "whether_approval_of_ca_sought_for_payment_of_emd_remarks",
//       },
//       {
//         label: "Whether EMD Paid?",
//         status: "whether_emd_paid_status",
//         planned: "whether_emd_paid_date_planned",
//         actual: "whether_emd_paid_date_actual",
//         remarks: "whether_emd_paid_remarks",
//       },
//       {
//         label: "Whether final allotment letter received from MIDC?",
//         status: "whether_final_allotment_letter_received_from_midc_status",
//         actual: "whether_final_allotment_letter_received_from_midc_date_actual",
//         remarks: "whether_final_allotment_letter_received_from_midc_remarks",
//       },
//       {
//         label: "Whether final payment made to MIDC?",
//         status: "whether_final_payment_made_to_midc_status",
//         actual: "whether_final_payment_made_to_midc_date_actual",
//         remarks: "whether_final_payment_made_to_midc_remarks",
//       },
//       {
//         label: "Whether lease deed executed with MIDC?",
//         status: "whether_lease_deed_executed_with_midc_status",
//         planned: "whether_lease_deed_executed_with_midc_date_planned",
//         actual: "whether_lease_deed_executed_with_midc_date_actual",
//         remarks: "whether_lease_deed_executed_with_midc_remarks",
//       },
//            {
//         label: "Lease deed details (Date, Period)",
//         status: "lease_deed_details_date_period_status",
//         remarks: "lease_deed_details_date_period_remarks",
//       },
//       {
//         label: "Whether possession of allotted plot taken?",
//         status: "whether_possession_of_allotted_plot_taken_status",
//         actual: "whether_possession_of_allotted_plot_taken_date_actual",
//         remarks: "whether_possession_of_allotted_plot_taken_remarks",
//       },
//     ];

//     return (
//       <Form form={form} layout="vertical">
//         <Card className="scheme-section-card" title={renderSectionTitle("PROPOSAL SUBMISSION")}>
//           {proposalRows.map((row) => (
//             <Card key={row.status} className="tracking-item-card">
//               <h4 className="tracking-question-label">{row.label}</h4>

//               <Row gutter={[16, 12]}>
//                 <Col xs={24} md={4}>
//                   <Form.Item name={row.status} label="Status">
//                     <Radio.Group>
//                       <Radio value="YES">Yes</Radio>
//                       <Radio value="NO">No</Radio>
//                     </Radio.Group>
//                   </Form.Item>
//                 </Col>

//                 {row.planned && (
//                   <Col xs={24} md={5}>
//                     <Form.Item name={row.planned} label="Date Planned">
//                       <DatePicker style={{ width: "100%" }} />
//                     </Form.Item>
//                   </Col>
//                 )}

//                 {row.actual && (
//                   <Col xs={24} md={row.planned ? 5 : 5}>
//                     <Form.Item name={row.actual} label="Date Actual">
//                       <DatePicker style={{ width: "100%" }} />
//                     </Form.Item>
//                   </Col>
//                 )}

//                 <Col xs={24} md={row.planned && row.actual ? 11 : (row.planned || row.actual) ? 15 : 20}>
//                   <Form.Item name={row.remarks} label="Remarks">
//                     <Input />
//                   </Form.Item>
//                 </Col>
//               </Row>
//             </Card>
//           ))}
//         </Card>
//       </Form>
//     );
//   }

//   return null;
// }

// export default MidcLandForm;
import React from "react";
import { Card, Row, Col, Radio, Input, DatePicker, Form, Tag } from "antd";
import dayjs from "dayjs";

function MidcLandForm({ form, tracking, stepKey }) {
  const sectionDateMap = {
    midc_1: tracking?.section1_planned_date,
    midc_2: tracking?.section2_planned_date,
    midc_3: tracking?.section3_planned_date,
  };

  const renderSectionTitle = (title) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <span>{title}</span>
      {sectionDateMap[stepKey] && (
        <Tag color="blue">
          Planned: {dayjs(sectionDateMap[stepKey]).format("DD MMM YYYY")}
        </Tag>
      )}
    </div>
  );

  // ── STEP 1: Land Demand & Type ─────────────────────────────────────────────
  if (stepKey === "midc_1") {
    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("LAND DEMAND & TYPE")}>
          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Whether Govt. Land available</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={6}>
                <Form.Item name="whether_govt_land_available_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                    <Radio value="PENDING">Pending</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Card>
      </Form>
    );
  }

  // ── STEP 2: Land Identification & Feasibility ──────────────────────────────
  if (stepKey === "midc_2") {
    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("LAND IDENTIFICATION & FEASIBILITY")}>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Whether MIDC land identified?</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={4}>
                <Form.Item name="whether_midc_land_identified_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="whether_midc_land_identified_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={15}>
                <Form.Item name="whether_midc_land_identified_remarks" label="Remarks">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Most feasible land identified</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={4}>
                <Form.Item name="most_feasible_land_identified_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item name="most_feasible_land_identified_date_actual" label="Date Actual">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={15}>
                <Form.Item name="most_feasible_land_identified_remarks" label="Remarks">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Feasibility ascertainment done (Electrical)</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={4}>
                <Form.Item name="feasibility_ascertainment_done_(electrical)_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={20}>
                <Form.Item name="feasibility_ascertainment_done_(electrical)_remarks" label="Remarks">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Feasibility ascertainment done (Civil)</h4>
            <Row gutter={[16, 12]}>
              <Col xs={24} md={4}>
                <Form.Item name="feasibility_ascertainment_done_(civil)_status" label="Status">
                  <Radio.Group>
                    <Radio value="YES">Yes</Radio>
                    <Radio value="NO">No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} md={20}>
                <Form.Item name="feasibility_ascertainment_done_(civil)_remarks" label="Remarks">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* Details of Feasible Land - the API stores survey/mouje/taluka/
             district/area/distance/remarks as one conceptual record, so it
             all lives in a single card here matching the real payload shape */}
          <Card className="tracking-item-card">
            <h4 className="tracking-question-label">Details of Feasible Land</h4>

            <Row gutter={[16, 12]}>
              <Col xs={24} md={12}>
                <Form.Item name="surveyno/gutno_details" label="SURVEY / GUT NO">
                  <Input placeholder="e.g. Plot No. E-21 / GUT-412 (Part)" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="mouje_details" label="MOUJE">
                  <Input placeholder="e.g. Chakan" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 12]}>
              <Col xs={24} md={12}>
                <Form.Item name="taluka_name" label="TALUKA">
                  <Input placeholder="e.g. Khed" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="district_name" label="DISTRICT">
                  <Input placeholder="e.g. Pune" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 12]}>
              <Col xs={24} md={12}>
                <Form.Item name="area_of_feasible_land_(ha/r)_area" label="AREA (Ha/R)">
                  <Input placeholder="e.g. 1.80 Hectares" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="distance_from_load_centre_(km)_distance" label="DISTANCE FROM LOAD CENTRE (km)">
                  <Input placeholder="e.g. 1.2 km" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 12]}>
              <Col xs={24}>
                <Form.Item name="area_and_distance_remarks" label="AREA AND DISTANCE REMARKS">
                  <Input.TextArea rows={4} placeholder="Enter detailed remarks..." />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 12]}>
              <Col xs={24}>
                <Form.Item name="details_of_feasible_land_remarks" label="DETAILS OF FEASIBLE LAND REMARKS">
                  <Input.TextArea rows={4} placeholder="Enter detailed remarks..." />
                </Form.Item>
              </Col>
            </Row>
          </Card>

        </Card>
      </Form>
    );
  }

  // ── STEP 3: Proposal Submission ────────────────────────────────────────────
  if (stepKey === "midc_3") {
    const proposalRows = [
      {
        label: "Whether requirement of land is submitted to MIDC office?",
        status: "whether_requirement_of_land_is_submitted_to_midc_office_status",
        actual: "whether_requirement_of_land_is_submitted_to_midc_office_date_actual",
        remarks: "whether_requirement_of_land_is_submitted_to_midc_office_remarks",
      },
      {
        label: "Whether online application submitted on MIDC portal?",
        status: "whether_online_application_submitted_on_midc_portal_status",
        actual: "whether_online_application_submitted_on_midc_portal_date_actual",
        remarks: "whether_online_application_submitted_on_midc_portal_remarks",
      },
      {
        label: "Whether MIDC office given demand letter for EMD?",
        status: "whether_midc_office_given_demand_letter_for_emd_status",
        actual: "whether_midc_office_given_demand_letter_for_emd_date_actual",
        remarks: "whether_midc_office_given_demand_letter_for_emd_remarks",
      },
      {
        label: "Whether approval of CA sought for payment of EMD?",
        status: "whether_approval_of_ca_sought_for_payment_of_emd_status",
        actual: "whether_approval_of_ca_sought_for_payment_of_emd_date_actual",
        remarks: "whether_approval_of_ca_sought_for_payment_of_emd_remarks",
      },
      {
        label: "Whether EMD Paid?",
        status: "whether_emd_paid_status",
        planned: "whether_emd_paid_date_planned",
        actual: "whether_emd_paid_date_actual",
        remarks: "whether_emd_paid_remarks",
      },
      {
        label: "Whether final allotment letter received from MIDC?",
        status: "whether_final_allotment_letter_received_from_midc_status",
        actual: "whether_final_allotment_letter_received_from_midc_date_actual",
        remarks: "whether_final_allotment_letter_received_from_midc_remarks",
      },
      {
        label: "Whether final payment made to MIDC?",
        status: "whether_final_payment_made_to_midc_status",
        actual: "whether_final_payment_made_to_midc_date_actual",
        remarks: "whether_final_payment_made_to_midc_remarks",
      },
      {
        label: "Whether lease deed executed with MIDC?",
        status: "whether_lease_deed_executed_with_midc_status",
        planned: "whether_lease_deed_executed_with_midc_date_planned",
        actual: "whether_lease_deed_executed_with_midc_date_actual",
        remarks: "whether_lease_deed_executed_with_midc_remarks",
      },
      {
        label: "Lease deed details (Date, Period)",
        status: "lease_deed_details_(date_period)_status",
        remarks: "lease_deed_details_(date_period)_remarks",
      },
      {
        label: "Whether possession of allotted plot taken?",
        status: "whether_possession_of_allotted_plot_taken_status",
        actual: "whether_possession_of_allotted_plot_taken_date_actual",
        remarks: "whether_possession_of_allotted_plot_taken_remarks",
      },
    ];

    return (
      <Form form={form} layout="vertical">
        <Card className="scheme-section-card" title={renderSectionTitle("PROPOSAL SUBMISSION")}>
          {proposalRows.map((row) => (
            <Card key={row.status} className="tracking-item-card">
              <h4 className="tracking-question-label">{row.label}</h4>

              <Row gutter={[16, 12]}>
                <Col xs={24} md={4}>
                  <Form.Item name={row.status} label="Status">
                    <Radio.Group>
                      <Radio value="YES">Yes</Radio>
                      <Radio value="NO">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                {row.planned && (
                  <Col xs={24} md={5}>
                    <Form.Item name={row.planned} label="Date Planned">
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                )}

                {row.actual && (
                  <Col xs={24} md={5}>
                    <Form.Item name={row.actual} label="Date Actual">
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                )}

                <Col xs={24} md={row.planned && row.actual ? 11 : (row.planned || row.actual) ? 15 : 20}>
                  <Form.Item name={row.remarks} label="Remarks">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          ))}
        </Card>
      </Form>
    );
  }

  return null;
}

export default MidcLandForm;